import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Button, Select, Text } from "react_reusable_components";

import AddProductCategoryFormLayout from "../../layouts/AddProductCategoryFormLayout/AddProductCategoryFormLayout";
import CustomInput from "../../components/CustomInput/CustomInput";
import ProductCategoryService from "../../services/product-category-service";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import Style from "./SubCategoriesFieldsContainer.module.scss";
import RenderDropDown from "../../components/RenderDropDown";

const SubCategoriesFieldsContainer = ({
  removeSubProductCategory,
  values,
  handleSubProductCategoryChange,
  handleChange,
  AddProductCategoryFormFieldName,
  userInput,
  setUserInput,
  isEditMode,
}) => {
  const intl = useIntl();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    ProductCategoryService.getCountries(intl).then((data) => {
      setCountries(data?.result);
      if (data?.result?.length > 1) {
        const allOption = {
          name: "All",
          id: "all",
        };
        setCountries((prev) => [...prev, allOption]);
      }
    });
  }, []);

  const handleCountryChange = (index, value) => {
    const selectedCountry =
      values?.[AddProductCategoryFormFieldName.SUB_CATEGORY][index]?.countryId;

    let newSelectedCountry = [];
    if (selectedCountry?.includes(value)) {
      if (value === "all") {
        newSelectedCountry = [];
      } else {
        newSelectedCountry = selectedCountry?.filter((option) => {
          return option !== value && option !== "all";
        });
      }
    } else {
      if (value === "all") {
        newSelectedCountry = countries?.map((item) => item.id);
      } else {
        newSelectedCountry = selectedCountry?.length
          ? [...selectedCountry, value]
          : [value];
      }
    }
    handleSubProductCategoryChange(index, "countryId", newSelectedCountry);
  };

  const getValue = (countryId) => {
    if (countryId?.length && countryId?.includes("all"))
      return countryId?.filter((id) => id !== "all");
    else {
      return countryId;
    }
  };

  useEffect(() => {
    if (
      !isEditMode &&
      values?.name?.length !== values?.subCategory?.[0]?.name?.length &&
      !userInput
    ) {
      handleSubProductCategoryChange(0, "name", values.name);
    }
  }, [values.name]);

  return (
    <div id="add-category" className={Style["add-product-div"]}>
      {values?.[AddProductCategoryFormFieldName.SUB_CATEGORY]?.map(
        ({ countryId, name }, index) => (
          <AddProductCategoryFormLayout
            key={index}
            firstSection={
              <CustomInput
                size={"small"}
                className={Style["Product-category-name"]}
                name={AddProductCategoryFormFieldName["SUB_CATEGORY.NAME"]?.(
                  index
                )}
                value={name}
                onChange={(e) => {
                  handleChange(e);
                  setUserInput(true);
                }}
                placeholder={getLocalizedMessage(
                  intl,
                  "productCategory.enterSubProductCategoryName"
                )}
              />
            }
            secondSection={
              <Select
                type="multipleSelect"
                onSelect={(value) => handleCountryChange(index, value)}
                onDeselect={(value) => handleCountryChange(index, value)}
                value={getValue(countryId)}
                mode="multiple"
                placeholder={getLocalizedMessage(
                  intl,
                  "productCategory.selectCountry"
                )}
                dropdownRender={() =>
                  RenderDropDown(countryId, countries, (id) =>
                    handleCountryChange(index, id)
                  )
                }
                options={countries?.map((country) => {
                  return {
                    label: (
                      <Text className={`${Style["select-item-style"]}`}>
                        {country.name}
                      </Text>
                    ),
                    value: country.id,
                  };
                })}
                showSearch={false}
              ></Select>
            }
            thirdSection={
              <Button
                className={`${Style["remove-category"]}`}
                onClick={() => removeSubProductCategory(index)}
              >
                <img
                  className={Style["icon"]}
                  alt={"icon"}
                  src={"/icons/close.svg"}
                />
              </Button>
            }
          />
        )
      )}
    </div>
  );
};

export default SubCategoriesFieldsContainer;
